export default "__VITE_PUBLIC_ASSET__5bf7eee8__"